import { request } from "../api";
import { unwrapList } from "./devices";

export type ScheduledReportFrequency = "daily" | "weekly" | "monthly";

/** Empty string means the report has never run yet. */
export type ScheduledReportLastStatus = "ok" | "error" | "skipped" | "";

/** Historical schedules only; no registered report types remain runnable. */
export interface ScheduledReport {
  id: string;
  report_type: string;
  report_type_label: string;
  name: string;
  recipients: string[];
  frequency: ScheduledReportFrequency;
  /** 0=Monday..6=Sunday. Set when frequency=weekly. */
  weekday: number | null;
  /** 1-28. Set when frequency=monthly. */
  day_of_month: number | null;
  /** 0-23, interpreted in the owning company's timezone. */
  hour: number;
  params: Record<string, number>;
  is_active: boolean;
  last_sent_at: string | null;
  last_status: ScheduledReportLastStatus;
  last_error: string;
  created_at: string;
  updated_at: string;
}

interface Paginated<T> {
  count?: number;
  next?: string | null;
  previous?: string | null;
  results?: T[];
}

export const scheduledReportsApi = {
  list: async () => {
    const data = await request<Paginated<ScheduledReport> | ScheduledReport[]>(
      `/api/admin/v1/scheduled-reports/`,
    );
    return unwrapList(data);
  },
  get: (id: string) =>
    request<ScheduledReport>(`/api/admin/v1/scheduled-reports/${id}/`),
  delete: (id: string) =>
    request<undefined>(`/api/admin/v1/scheduled-reports/${id}/`, { method: "DELETE" }),
};
